module.exports = __webpack_public_path__ + "static/media/hnsw.02a994f9.mp4";